import React from 'react';

interface IScreenReaderAnnounceProps {
  message: string;
}

const visuallyHiddenStyle: React.CSSProperties = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

const ScreenReaderAnnounce: React.FC<IScreenReaderAnnounceProps> = ({ message }) => (
  <div role="status" aria-live="polite" aria-atomic="true" style={visuallyHiddenStyle}>
    {message}
  </div>
);

export default ScreenReaderAnnounce;
